import React, { useContext, useState, useEffect } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import { DataGridPro } from '@mui/x-data-grid-pro';
// API
import {
  postProductTeamPresentedExport,
  postProductTeamPresentedList,
} from '../../../../api/productUtilDashboardApi';
// Context
import useProductUtilizationDashboardContext from '../../context/useProductUtilizationDashboardContext';

export default function ProductTeamPresentedModal() {
  const { filterForm, ptpModal, setPtpModal } = useContext(useProductUtilizationDashboardContext);
  const [exportLoading, setExportLoading] = useState(false);
  const [table, setTable] = useState({ loading: false, rows: [] });
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'manager_name',
      headerName: 'Manager Name',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'rep_name',
      headerName: 'Med Rep Name',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'presented',
      headerName: 'Presented',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.presented),
    },
  ];

  const handleClose = () => {
    setPtpModal(false);
  };

  const handleExportReport = async () => {
    try {
      toast.loading('Processing request plase kindly wait...');
      setExportLoading(true);

      const request = {
        team: filterForm?.team?.value,
        agenda_id:
          filterForm?.agenda[0].value !== null ? filterForm?.agenda?.map((row) => row.value) : [],
        date_from: filterForm?.date_from,
        date_to: filterForm?.date_to,
      };
      const response = await postProductTeamPresentedExport(request);
      const { code, result } = response.data.response;

      toast.dismiss();
      if (code === '200') {
        window.location.href = result;

        toast.success(`Successfully exported file: ${response?.data?.response?.file_name}`);
      }
      setExportLoading(false);
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleGenerateReport = async () => {
    try {
      setTable({ ...table, loading: true });
      const request = {
        team: filterForm?.team?.value,
        agenda_id:
          filterForm?.agenda[0].value !== null ? filterForm?.agenda?.map((row) => row.value) : [],
        date_from: filterForm?.date_from,
        date_to: filterForm?.date_to,
      };

      const response = await postProductTeamPresentedList(request);
      const { code, data } = response.data;

      if (code === '200') {
        setTable({ ...table, loading: false, rows: data });
      }
    } catch (error) {
      toast.dismiss();
    }
  };

  const pinnedRows = {
    top: table?.rows?.length ? [table?.rows[0]] : [],
  };

  useEffect(() => {
    handleGenerateReport();
  }, [ptpModal]);
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby='customized-dialog-title'
      fullWidth='xl'
      maxWidth='xl'
      open={ptpModal}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id='customized-dialog-title'>
        Product Team Presented Breakdown
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            sx={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <Button
              variant='contained'
              color='success'
              loading={exportLoading}
              onClick={handleExportReport}
            >
              Export Report
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box
              className='table-container'
              sx={{
                height: `600px`,
                '& .super-app-theme--header': {
                  fontWeight: 'bold',
                  backgroundColor: '#808080',
                  color: '#fff',
                },
                '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#FBCEB1' },
              }}
            >
              <DataGridPro
                loading={table?.loading}
                rows={table?.rows}
                columns={columns}
                sortModel={sortModel}
                experimentalFeatures={{ rowPinning: true }}
                pinnedRows={pinnedRows}
                initialState={{
                  ...table?.rows?.initialState,
                  pagination: {
                    pageSize: 50,
                  },
                }}
                rowsPerPageOptions={[10, 25, 50]}
                pagination
                onSortModelChange={(model) => setSortModel(model)}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='error' onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
